<template>
    <div class="main">
        <div class="back" @click="router.push('/carManage/cars')"> <a-button type="primary"><i
                    class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button></div>

        <tableItem :tableStatus="0" :tableObjTitle="tableTitle" :tableObjData="tableObj">
            <template v-slot:headTitle>
                车牌号：{{ tableObj.testCarNum }}
            </template>
        </tableItem>

        <div class="mt60">
            <a-tabs v-model:activeKey="activeKey" @change="getData">
                <a-tab-pane key="0" tab="基本信息">

                    <tableItem :tableStatus="0"
                        :tableObjTitle="store.roles.includes('carEnterprise') ? informationTitle2 : informationTitle"
                        :tableObjData="informationObj">
                        <template v-slot:headTitle>
                            基本信息
                        </template>
                    </tableItem>

                </a-tab-pane>
                <a-tab-pane key="1" tab="资质详情">
                    <div class="table">

                        <div class="tab_two_title">智能网联汽车道路测试申请/应用示范申请历史记录</div>

                        <tableItem :tableStatus="1" :tableArrayTitle="firstTitle" :tableArrayData="firstData"
                            :tableStyle="tableStyle">
                        </tableItem>


                        <div class="tab_two_title" style="margin: 24px 0;">智能网联汽车道路/示范应用延期申请</div>

                        <tableItem :tableStatus="1" :tableArrayTitle="secondTitle" :tableArrayData="secondData"
                            :tableStyle="tableStyle">
                        </tableItem>

                    </div>
                </a-tab-pane>
                <a-tab-pane key="2" tab="信息变更">

                    <div class="table">

                        <div class="tab_two_title">历史申请记录</div>

                        <tableItem :tableStatus="1" :tableArrayTitle="thirdlyTitle" :tableArrayData="thirdlyData"
                            :tableStyle="messageTableStyle">
                            <template v-slot:action="text, record" >
                                <a-button type="primary" @click="handleEdit(record)">查看</a-button>
                                <a-button type="primary" @click="handleChangeDetail(record)" v-if="record.type === 2" style="margin-left: 8px;">变更详情</a-button>
                            </template>
                        </tableItem>

                    </div>

                </a-tab-pane>
                <a-tab-pane key="3" tab="测试记录">
                    <div class="box">
                        <div class="title">测试记录</div>
                        <a-table :columns="columns" :row-key="(record) => record.id" :data-source="dataSource"
                            size="middle" class="mt23" :pagination="pagination" :scroll="{ y: 'auto', }"
                            v-autoHeight="{ extraHeight: 88, trHeight: 47 }">
                            <template #bodyCell="{ column, record }">
                                <template v-if="column.key === 'reservation'">
                                    {{ reservation ? '是' : '否' }}
                                </template>
                                <template v-if="column.key === 'personName'">
                                    <div v-html="getPerson(record.testPersons)"></div>
                                </template>
                                <template v-if="column.key === 'testType'">
                                    {{ getSingleTypeValue(appStore.SysDictVOList, 'testType' + 'category' +
                                        record.testType) }}
                                </template>
                                <template v-if="column.key === 'endDetailStatus'">
                                    endDetailStatus
                                </template>
                                <template v-if="column.key === 'testtime'">
                                    {{ record.startTimeStr }} 至 {{ record.endTimeStr }}
                                </template>
                                <template v-else-if="column.key === 'action'">
                                    <span>
                                        <a class="ml10" @click="jumpDetail(record)">详情</a>
                                        <!-- <a class="ml10" :href="record.reportFileUrl"
                                            v-if="record.reportFileUrl">测试报告</a> -->
                                        <a class="ml10" v-if="record.reportFileUrl">测试报告</a>
                                    </span>
                                </template>
                            </template>
                        </a-table>
                    </div>

                </a-tab-pane>
            </a-tabs>
        </div>
    </div>
</template>
<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import tableItem from '@/components/tableItem/index.vue'
import useUserStore from '@/store/modules/user'
import useAppStore from "@/store/modules/app";
import { getSingleTypeValue } from "@/utils/matchDic.js";
import { getCarDetail } from "@/api/car/car.js";

const activeKey = ref('0');
const router = useRouter()
const route = useRoute()
const store = useUserStore();
const appStore = useAppStore();

const columns = [
    {
        title: "序号",
        dataIndex: "id",
        key: "id",
        width: 50
    },
    {
        title: "申请时间",
        dataIndex: "applyTimeStr",
        key: "applyTimeStr",
    },
    {
        title: "测试区域",
        dataIndex: "testZone",
        key: "testZone",
        width: 100,
    },
    {
        title: "测试类型",
        key: "testType",
        dataIndex: "testType",
    },
    {
        title: "测试人员",
        key: "personName",
        dataIndex: "personName",
        // width: 115
    },
    {
        title: "测试道路",
        key: "testZoneDetail",
        dataIndex: "testZoneDetail",
        // width: 240,
    },
    {
        title: "是否需要预约",
        key: "reservation",
        dataIndex: "reservation",
    },
    {
        title: "测试时间",
        key: "testtime",
        dataIndex: "testtime",
        width: 165
    },
    {
        title: "状态",
        key: "endDetailStatus",
        dataIndex: "endDetailStatus",
        width: 70
    },
    {
        title: "结果",
        key: "checkResult",
        dataIndex: "checkResult",
    },
    {
        title: "操作",
        key: "action",
    },
];


const tableTitle = ref([
    { tableLeft: '创建人', tableRight: '更新人', dataSource: 'createByName', innerDataSource: 'updateByName' },
    { tableLeft: '创建时间', tableRight: '更新时间', dataSource: 'createTime', innerDataSource: 'updateTime' },
])

const tableObj = ref({
    testCarNum: '',
    createByName: '',
    updateByName: '',
    createTime: '',
    updateTime: ''
})

// 基本信息
const informationTitle = ref([
    { tableLeft: '企业名称', dataSource: 'deptName', tableRight: '监管装置', innerDataSource: 'bindMonitorDevice' },
    { tableLeft: '测试牌照', dataSource: 'testCarNum', tableRight: '自动驾驶级别', innerDataSource: 'dynamicDriverLevel' },
    { tableLeft: '车牌颜色', dataSource: 'carPlateColor', tableRight: '车辆颜色', innerDataSource: 'carColor' },
    { tableLeft: '车辆类型', dataSource: 'carType', tableRight: '车辆状态', innerDataSource: 'carStatus' },
    { tableLeft: '车辆型号', dataSource: 'carModel', tableRight: '车辆品牌', innerDataSource: 'carBrand' },
    { tableLeft: '最大容量', dataSource: 'maxCapacity', tableRight: '能耗类型', innerDataSource: 'energyType' },
])

// 基本信息 车企端
const informationTitle2 = ref([
    { tableLeft: '测试牌照', dataSource: 'testCarNum', tableRight: '自动驾驶级别', innerDataSource: 'dynamicDriverLevel' },
    { tableLeft: '车牌颜色', dataSource: 'carPlateColor', tableRight: '车辆颜色', innerDataSource: 'carColor' },
    { tableLeft: '车辆类型', dataSource: 'carType', tableRight: '车辆状态', innerDataSource: 'carStatus' },
    { tableLeft: '车辆型号', dataSource: 'carModel', tableRight: '车辆品牌', innerDataSource: 'carBrand' },
    { tableLeft: '最大容量', dataSource: 'maxCapacity', tableRight: '能耗类型', innerDataSource: 'energyType' },
    { tableLeft: '监管装置', dataSource: 'bindMonitorDevice', tableRight: '', innerDataSource: '' },
])

const informationObj = ref({
    deptName: "",
    testCarNum: "",
    manufacturingEnterprise: '',
    dynamicDriverLevel: "",
    carModel: '',
    carType: "",
    engineNumber: '',
    carColor: '',
    manufactureTime: '',
    vin: "",
    bindMonitorDevice: ''
})

// 资质详情
const tableStyle = ref({
    screenHeight: 0,
    isStyle: true
})
// 信息变更
const messageTableStyle = ref({
    screenHeight: 0,
    isStyle: true,
    personnel: true
})
const firstTitle = ref([
    { title: '序号', dataSource: 'ranking' },
    { title: '测试类型', dataSource: 'categoryTxt' },
    { title: '资质申请时间', dataSource: 'applyTimeStr' },
    { title: '测试有效期', dataSource: 'TestValidityPeriod' },
    { title: '审核结果', dataSource: 'checkResult' },
])

const firstData = ref([])

const secondTitle = ref([
    { title: '序号', dataSource: 'ranking' },
    { title: '测试类型', dataSource: 'categoryTxt' },
    { title: '申请时间', dataSource: 'applyTimeStr' },
    { title: '延期日期', dataSource: 'delayTimeStr' },
    { title: '审核结果', dataSource: 'checkResult' },
])

const secondData = ref([])

const thirdlyTitle = ref([
    { title: '申请时间', dataSource: 'applyTime' },
    { title: '申请类型', dataSource: 'typeStr' },
    { title: '审核意见', dataSource: 'checkOpinion' },
    { title: '操作', dataSource: '' },
])
const thirdlyData = ref([])

const dataSource = ref([]);


const pagination = reactive({
    total: 0,
    size: "middle",
    defaultPageSize: 10,
    current: 1,
    pageSize: 20, //每页中显示10条数据
    showSizeChanger: true,
    showQuickJumper: false,
    pageSizeOptions: ["10", "20", "30"], //每页中显示的数据
    showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
    onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
    onChange: pageChange, //点击页码事件
    showSizeChange: pageSizeChange,
});

function pageChange(page, pageSize) {
    pagination.current = page;

    // 获取表格数据
    getData();
}

function pageSizeChange(current, size) {
    console.log(size);
    pagination.pageSize = size;

    // 获取表格数据 
    getData();
}

const getData = () => {
    getCarDetail({ id: route.query.id, type: activeKey.value }).then(res => {
        if (res.code == 200) {

            if (activeKey.value == '0') {
                res.data.carInfo.bindMonitorDevice = res.data.carInfo.bindMonitorDevice == '0' ? '未安装' : '已安装'
                res.data.carInfo.carPlateColor ? res.data.carInfo.carPlateColor = getSingleTypeValue(appStore.SysDictVOList, 'carInfo' + 'plateColor' + res.data.carInfo.carPlateColor) : res.data.carInfo.carPlateColor = ''
                res.data.carInfo.carColor ? res.data.carInfo.carColor = getSingleTypeValue(appStore.SysDictVOList, 'carInfo' + 'fuselageColor' + res.data.carInfo.carColor) : res.data.carInfo.carColor = ''
                res.data.carInfo.carType ? res.data.carInfo.carType = getSingleTypeValue(appStore.SysDictVOList, 'carInfo' + 'category' + res.data.carInfo.carType) : res.data.carInfo.carType = ''
                tableObj.value = res.data.defaultInfo;
                informationObj.value = res.data.carInfo;
                console.log(res.data.carInfo);
                // 
            } else if (activeKey.value == '1') {
                res.data.qualification.map(item => {
                    item.categoryTxt = getSingleTypeValue(appStore.SysDictVOList, 'testType' + 'category' + item.category);
                    item.TestValidityPeriod = item.testStartTimeStr + '~' + item.testEndTimeStr;
                })
                firstData.value = res.data.qualification;
                res.data.delay.map(item => {
                    item.categoryTxt = getSingleTypeValue(appStore.SysDictVOList, 'testType' + 'category' + item.category);
                })
                secondData.value = res.data.delay;
            }
            if (activeKey.value == '2') {
                // 处理申请类型
                res.data.changeInfo.forEach(item => {
                    if (item.type === 1) {
                        item.typeStr = '基础信息变更';
                    } else if (item.type === 2) {
                        item.typeStr = '测试牌照更新';
                    } else {
                        item.typeStr = '未知类型';
                    }
                });
                thirdlyData.value = res.data.changeInfo
            } else if (activeKey.value == '3') {
                dataSource.value = res.data.taskInfo
            }
        }
    })
}

function getPerson(list) {
    let arr = [], arr2 = [];
    list?.map(item => {
        if (item.personType.indexOf('driver') > -1) {
            arr.push(item.name);
        }
        if (item.personType.indexOf('security') > -1) {
            arr2.push(item.name);
        }
    })
    return '驾驶员：' + arr.join(',') + ' <br/> ' + '安全员：' + arr2.join(',')
    console.log(arr, arr2)
}

const jumpDetail = (record) => {
    router.push({
        path: "/testManage/taskDetail",
        query: {
            activeKey: '0',
            type: '0',//  0 查看详情模式  ，1编辑模式
            from: "0",  //来源 0 testManage/task  ，1  testManage/reservation
            id: record.id,
        }
    });
}

onMounted(() => {
    getData();
    tableStyle.value.screenHeight = window.innerHeight
    console.log(tableStyle.value.screenHeight,);
    window.onresize = () => {
        return (() => {
            tableStyle.value.screenHeight = window.innerHeight
        })()
    }
})
</script>
<style lang="less" scoped>
.main {
    padding: 20px;
    height: calc(100vh - 70px - 57px);
    background-color: #ffffff;

    .back {
        position: fixed;
        top: 93px;
        right: 50px
    }

    .table {
        width: 870px;
        margin: 0 auto;
    }

    .tab_two_title {
        width: 870px;
        margin: 0 auto;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        color: #1D2129;
        margin: 16px 0 24px 0;
        position: relative;
        padding-left: 30px;

        &::before {
            content: '';
            display: inline-block;
            width: 3px;
            height: 13px;
            border-radius: 4px;
            background: #1E8EF2;
            position: absolute;
            left: 19px;
            top: 4px;
        }
    }

    .box {
        width: 80%;
        margin: 0 auto;
    }

    .title {
        position: relative;
        font-size: 14px;
        font-weight: 600;
        color: #1D2129;
        line-height: 16px;
        padding-left: 10px;
        margin: 16px 0 24px 0;

        &::before {
            content: "";
            display: inline-block;
            height: 100%;
            width: 3px;
            background: #1E8EF2;
            position: absolute;
            top: 0;
            left: 0;
        }
    }

    .mt60 {
        margin-top: 60px;
    }

    .mt16 {
        margin-top: 16px;
    }
}

/deep/.ant-table {
    a {
        color: #1E8EF2;
    }
}

/deep/.ant-tabs .ant-tabs-tab+.ant-tabs-tab {
    margin: 0 0 0 114px;

}

/deep/.ant-tabs .ant-tabs-tab {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: rgba(29, 33, 41, 0.7);
}

/deep/.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    color: #1D2129;
}

/deep/.ant-tabs>.ant-tabs-nav .ant-tabs-nav-wrap {
    justify-content: center;
}

/deep/.ant-tabs-top>.ant-tabs-nav .ant-tabs-ink-bar {
    height: 3px;
}
</style>
